exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#configurations-general-visual-tab td {\n  line-height: 2;\n}[dir] #configurations-general-visual-tab td {\n  border-top: 1px solid #c0c0c0;\n}\n[dir] #configurations-general-visual-tab .vs-con-table .vs-con-tbody {\n  border: 1px solid #c0c0c0;\n}\n[dir] .tab-action-btn-fill-conatiner.con-vs-tabs .vs-tabs--content {\n  padding: 0px 10px !important;\n}\n[dir] .vs-table--not-data {\n  padding: 0px;\n}\n", ""]);

// exports
